// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BannerRight_wrapper__3BP9w","category_wrapper":"BannerRight_category_wrapper__i1h7h","post_card":"BannerRight_post_card__2V67d"};